import { render, staticRenderFns } from "./VideoAdvertise.vue?vue&type=template&id=2b6b3d78&scoped=true&"
import script from "./VideoAdvertise.vue?vue&type=script&lang=js&"
export * from "./VideoAdvertise.vue?vue&type=script&lang=js&"
import style0 from "./VideoAdvertise.vue?vue&type=style&index=0&id=2b6b3d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b3d78",
  null
  
)

export default component.exports